import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`